// extracted by mini-css-extract-plugin
export var container = "Breadcrumb-module--container--aaecc";